import { AbstractPmsApiService } from "./abstract.service";
import { AmenityCategory } from "../models";

/**
 * @class AmenityCategoryPmsApiService
 * @abstract
 * @extends {AbstractPmsApiService<AmenityCategory>}
 */
export class AmenityCategoryPmsApiService extends AbstractPmsApiService {
    
    /**
     * @type {string[]}
     */
    static get $inject() {
        
        return super.$inject.concat([ 'Upload' ]);
    }
    
    constructor(http, config, eventsBroker, Upload) {
        
        super(http, config, eventsBroker);
        
        this.Upload = Upload;
    }
    
    /**
     * @type {string}
     * @protected
     */
    get urlPattern() {
        
        return '/amenity-category(/:id)';
    }
    
    /**
     * @param {Object.<string, *>} attributes
     * @returns {AmenityCategory}
     * @protected
     */
    newModel(attributes) {
        
        return new AmenityCategory(attributes);
    }
    
    /**
     * @param {Object} params
     * @returns {Promise.<PaginationCollection<AmenityCategory>>}
     */
    get (params = {}) {
        
        const url = this.url();
        const ignoreLB = params.hasOwnProperty('searchValue');
        return this.http
                   .get(url, {
                       headers: this.authHeaders,
                       params,
                       ignoreLoadingBar: ignoreLB
                   })
                   .then(this.getPaginationCollector())
                   .catch(this.getErrorHandler());
    }
    
    /**
     * @param {AmenityCategory} amenityCategory
     * @returns {Promise.<AmenityCategory>}
     */
    create(amenityCategory) {
        
        const url = this.url();
        
        return this.Upload
                   .upload({
                       url:     url,
                       headers: this.authHeaders,
                       data:    amenityCategory.toObject()
                   })
                   .then(this.getModeler())
                   .catch(this.getErrorHandler());
    }
    
    /**
     * @param {AmenityCategory} amenityCategory
     * @returns {Promise.<AmenityCategory>}
     */
    update(amenityCategory) {
        
        const url = this.url({id: amenityCategory.id});
        
        if (amenityCategory.image_file instanceof File) {
            
            let data = amenityCategory.toObject();
            
            delete data.image;
            
            return this.Upload
                       .upload({
                           url:     url,
                           headers: this.authHeaders,
                           data:    data
                       })
                       .then(this.getModeler())
                       .catch(this.getErrorHandler());
            
        }
        
        return this.http
                   .put(url, amenityCategory.copyExcept('image_file'), {
                       headers: this.authHeaders
                   })
                   .then(this.getModeler())
                   .catch(this.getErrorHandler());
    }

    /**
     * @param {AmenityCategory} amenityCategory
     * @returns {Promise.<boolean>}
     */
    delete(amenityCategory) {
        
        const url = this.url({id: amenityCategory.id});
        
        return this.http
                   .delete(url, {
                       headers: this.authHeaders
                   })
                   .then(this.getStatusExtractor())
                   .catch(this.getErrorHandler());
    }

    /**

     * @param {Integer} amenityId
     * @param {Object} params
     */
    show(amenityId, params = {}) {

        const url = this.url({
            id: amenityId
        });

        return this.http
            .get(url, {
                headers: this.authHeaders,
                params
            })
            .then(this.getModeler())
            .catch(this.getErrorHandler());
    }
}


// WEBPACK FOOTER //
// ./src/pms-api/services/amenity-category.service.js